export const makeParse =
  <X>(options: { isTrue: (x: X) => boolean; isFalse: (x: X) => boolean }) =>
  (x: X) => {
    if (options.isTrue(x)) {
      return true
    }
    if (options.isFalse(x)) {
      return false
    }
    return undefined
  }

/**
 * ```
 * 'true' | 'false'
 * ```
 */
export const parseString = makeParse<string>({
  isTrue: (x) => x === 'true',
  isFalse: (x) => x === 'false',
})
